export enum KykkaState {
    InCity, //на передней границе или в городе
    OnLine, // боковая или задняяя границы
    OutCity, // за пределами города
    Guest // перед линией кюкей
}